import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import template from './radioButtons.jsx';
import { generateChildrenFromOptions } from './radioButtonsHelpers';

var validateOptions = function validateOptions(props, propName, compName, locationName) {
  if (_.isEmpty(props[propName]) === _.isEmpty(props.children)) {
    return new Error("Exactly one of ".concat(propName, " property and children can be specified in ").concat(compName, "."));
  }

  var optionsType = {
    options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string,
      disabled: PropTypes.bool
    }))])
  };
  PropTypes.checkPropTypes(optionsType, props, locationName, compName);
};

var RadioButtons = /*#__PURE__*/function (_React$Component) {
  _inherits(RadioButtons, _React$Component);

  var _super = _createSuper(RadioButtons);

  function RadioButtons(props) {
    var _this;

    _classCallCheck(this, RadioButtons);

    _this = _super.call(this, props);
    _this.groupId = _.uniqueId('radioGroup');

    _this.generateChildren = function () {
      return _this.props.options ? generateChildrenFromOptions(_this.props) : _.castArray(_this.props.children);
    };

    return _this;
  }

  _createClass(RadioButtons, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return RadioButtons;
}(React.Component);

RadioButtons.displayName = 'RadioButtons';
RadioButtons.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  labelTemplate: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  // React class / functional comp
  options: validateOptions,
  disabled: PropTypes.bool,
  radioItemPredicate: PropTypes.func,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  showRadioSymbol: PropTypes.bool,
  selectionArea: PropTypes.bool
};
RadioButtons.defaultProps = {
  disabled: false,
  radioItemPredicate: function radioItemPredicate(item) {
    return _.has(item, 'props.value');
  },
  orientation: 'vertical',
  showRadioSymbol: true
};
export default compose(RadioButtons);